import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';
import ipModal from '@mockup/func/globals/ip.modal';

export const leaveGuide = {
    init: function () {
        ipModal.init();
        window.exitIpModal = ipModal;

        $('.exit-feedback-content').each(function () {
            var lightboxContent = $(this);

            lightboxContent.find('input[type=radio]').on('change', function () {
                if (lightboxContent.find('.feedback-other-reason-radio input').is(':checked')) {
                    lightboxContent.find('.feedback-other-reason-explanation').removeClass('hide');
                    lightboxContent.find('.feedback-other-reason-explanation textarea').focus();
                } else {
                    lightboxContent.find('.feedback-other-reason-explanation').addClass('hide');
                }

            });

            $('form[data-leaveguide-ajax="true"]').submit(function () {
                $('#btnFarvelFraGuide').toggleClass('is-loading').prop('disabled', true);

                var $form = $(this);
                var rUri = $form.find('input[name = "RefererUri"]').val();
                var question = $form.find('input[type=radio][name=beskrivelse]:checked').attr('id');
                var description = $form.find('textarea[name="tilfojelse"]').val();

                if (typeof window.ga === 'function') {
                    if (question !== undefined) {
                        if (question === 'Guide_Question_4') {
                            if (description.length > 0) {
                                window.ga('send', 'event', 'Login', 'Feedback', 'Forlad_' + question + '_Med_Fritekst_' + rUri);
                            } else {
                                window.ga('send', 'event', 'Login', 'Feedback', 'Forlad_' + question + '_Uden_Fritekst_' + rUri);
                            }
                        } else {
                            window.ga('send', 'event', 'Login', 'Feedback', 'Forlad_' + question + '_' + rUri);
                        }
                    } else {
                        window.ga('send', 'event', 'Login', 'Feedback', 'Forlad_Ikke_Svaret_' + rUri);
                    }
                }

                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method'),
                    data: $form.serialize()
                }).done(function (data) {
                    if (data.ok) {
                        if (data.redirectLink) {
                            $('#btnFarvelFraGuide').prop('disabled', false);
                            $('.btnrow.size-l').slideUp();
                            $('#lblLeaveGuideKvittering').slideDown();
                            $.fancybox.update();
                            setTimeout(function () {
                                $.fancybox.close();
                                var url = top.location.protocol + '//' + top.location.hostname + data.redirectLink;
                                top.location.assign(url);
                            }, 2000);
                        }
                    }
                });

                return false;
            });
        });
    }
};

export default leaveGuide;

App.Util.leaveGuide = leaveGuide;
